require('../../../modules/es.string.starts-with');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').startsWith;